function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L24 0L24 24L0 24L0 0Z",
  id: "check_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "check_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#check_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "bx:bxs-check-circle"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L24 0L24 24L0 24L0 0Z",
  id: "bx:bxs-check-circle-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#check_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM4.99329 10.0007L4.99471 9.99929Q5.06416 9.92964 5.14587 9.87489Q5.22758 9.82013 5.3184 9.78238Q5.40922 9.74462 5.50567 9.72531Q5.60211 9.70601 5.70047 9.7059Q5.79883 9.70578 5.89532 9.72487Q5.99181 9.74395 6.08272 9.7815Q6.17363 9.81905 6.25546 9.87362Q6.3373 9.92819 6.40691 9.99768L7.999 11.587L12.5867 6.99929Q12.6563 6.92973 12.7381 6.87507Q12.8199 6.82042 12.9108 6.78277Q13.0016 6.74512 13.0981 6.72593Q13.1946 6.70674 13.293 6.70674Q13.3914 6.70674 13.4879 6.72593Q13.5844 6.74512 13.6752 6.78277Q13.7661 6.82042 13.8479 6.87507Q13.9297 6.92973 13.9993 6.99929L14.0007 7.00071Q14.0703 7.07027 14.1249 7.15207Q14.1796 7.23387 14.2172 7.32476Q14.2549 7.41565 14.2741 7.51213Q14.2933 7.60862 14.2933 7.707Q14.2933 7.80538 14.2741 7.90187Q14.2549 7.99835 14.2172 8.08924Q14.1796 8.18013 14.1249 8.26193Q14.0703 8.34373 14.0007 8.41329L8.001 14.413L4.99506 11.4135Q4.92541 11.344 4.87065 11.2623Q4.8159 11.1805 4.77814 11.0897Q4.74038 10.9988 4.72107 10.9024Q4.70176 10.8059 4.70164 10.7075Q4.70152 10.6091 4.72059 10.5126Q4.73966 10.416 4.77719 10.3251Q4.81472 10.2341 4.86927 10.1523Q4.92382 10.0704 4.99329 10.0007L4.99329 10.0007Z",
  transform: "translate(2 2)",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgCheckCircle = function SvgCheckCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-circle.6e71af06.svg";
export { ForwardRef as ReactComponent };